// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"sharing-module--button-row--11Nf6","sharingButton":"sharing-module--sharing-button--2LLEA"};